import { useEffect, useState } from "react";
import axiosInstance from "../axiosInstance";

export default function CreateBranch() {
  const API = process.env.REACT_APP_API_URL;
  const [name, setName] = useState("");
  const [branches, setBranches] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  const fetchBranches = async () => {
    try {
      setLoading(true);
      const response = await axiosInstance.get(`${API}/api/get/branches/`);
      setBranches(response.data || []);
    } catch (err) {
      setError("Unable to load branches.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBranches();
  }, []);

  const addBranch = async (event) => {
    event.preventDefault();
    const branchName = name.trim();

    if (!branchName) {
      setError("Enter a branch name.");
      return;
    }

    try {
      setSaving(true);
      setError("");
      await axiosInstance.post(`${API}/api/add/branch/`, { name: branchName });
      setName("");
      await fetchBranches();
    } catch (err) {
      setError(err.response?.data?.error || "Unable to create branch.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className=" mx-auto space-y-5 mt-10">
      <div className=" bg-white border border-slate-200  rounded-xl  p-5 shadow-sm">
        <h1 className="text-xl font-bold text-slate-800">Branches</h1>
        {/* <p className="mt-1 text-sm text-slate-500">Manage ticket locations and user branches.</p> */}
      </div>

      <form onSubmit={addBranch} className="rounded-xl border border-slate-200 bg-white p-5 shadow-sm max-w-2xl">
        <label htmlFor="branch-name" className="block text-sm font-semibold text-slate-700 mb-2">
          Add branch
        </label>
        <div className="flex flex-col sm:flex-row gap-2">
          <input
            id="branch-name"
            value={name}
            onChange={(event) => setName(event.target.value)}
            placeholder="e.g. Velachery"
            className="h-10 flex-1 rounded-lg border border-slate-200 px-3 text-sm outline-none focus:border-sky-400 focus:ring-2 focus:ring-sky-100"
          />
          <button
            type="submit"
            disabled={saving}
            className="h-10 rounded-lg bg-sky-600 px-4 text-sm font-semibold text-white hover:bg-sky-700 disabled:bg-slate-300"
          >
            {saving ? "Adding..." : "Add Branch"}
          </button>
        </div>
        {error && <p className="mt-2 text-sm text-red-600">{error}</p>}
      </form>

      <div className="rounded-xl border border-slate-200 bg-white p-5 shadow-sm max-w-2xl">
        <h2 className="text-sm font-semibold text-slate-700">Registered branches</h2>
        {loading ? (
          <p className="mt-3 text-sm text-slate-500">Loading branches...</p>
        ) : (
          <div className="mt-3 divide-y divide-slate-100">
            {branches.map((branch) => (
              <div key={branch.id} className="py-3 text-sm text-slate-700">
                {branch.name}
              </div>
            ))}
            {!branches.length && <p className="py-3 text-sm text-slate-500">No branches added yet.</p>}
          </div>
        )}
      </div>
    </div>
  );
}
